import { Component } from '@angular/core';

@Component({
  selector: 'app-communal-premise-purchase-portal',
  templateUrl: './communal-premise-purchase-portal.component.html',
  standalone: false,
})
export class CommunalPremisePurchasePortalComponent {}
